import { DataAccessService } from './data-access.service';
import { interval, Subscription } from 'rxjs';
import { Injectable, Input, OnInit } from '@angular/core';
import { GlobalIntervalService } from './global-interval-service.service';

//@Injectable()
export class TranslationService {

    private Dictionary: any;
    private MissingKeys: any;
    private Initialized: boolean;
    private PlaceHolderSymbol: string = '@@@';
    private dataAccess: DataAccessService;
    private InsertUiTextInterval: Subscription = null;
    private destroyed: boolean = false;

    constructor(private globalInterval: GlobalIntervalService = new  GlobalIntervalService()) {
        
    }

    public init(namespaces: string[], dataAccess: DataAccessService, component:OnInit = null): void {

        if (this.Initialized)
            return;

        this.dataAccess = dataAccess;

        this.MissingKeys = {};

        this.dataAccess.getUiTextsAnonymous([this.dataAccess.LanguageKey], namespaces, null).subscribe((r) => {
            this.Dictionary = r;
            this.Initialized = true;

            //if (this.UploadInterval == null) {
            //    this.UploadInterval = interval(3000).subscribe((n) => {
            //        if (Object.keys(this.MissingKeys).length > 0) {
            //            this.dataAccess.insertUiTexts(this.MissingKeys).subscribe((r) => {
            //                this.MissingKeys = {};
            //            });
            //        }
            //    });
            //}

            if (this.InsertUiTextInterval === null) {
                this.InsertUiTextInterval = this.globalInterval._3SecondTick.subscribe((n) => {
                    //This will pile up, a new instance is created for every component. And they all subscribe to this and stay alive. Uncomment the below to see this
                    //console.log('Insert UI Text Interval');

                    //Update: The above is solved by sending the component to ts. And then destroying the ts on ionViewWillLeav
                    if (Object.keys(this.MissingKeys).length > 0) {
                        this.dataAccess.insertUiTexts(this.MissingKeys).subscribe((r) => {
                            this.MissingKeys = {};
                        });
                    }

                    if (this.destroyed)
                        this.InsertUiTextInterval.unsubscribe();
                });
            }

        });
    }

    public translate(key: string, defaultText: string, variables: string[] = [], debug: boolean = false): string {

        if (debug) {
            alert(this.Dictionary[key])
        }

        if (!this.Dictionary)
            return '&nbsp;';

        if (this.Dictionary[key] === undefined) {
            this.MissingKeys[key] = defaultText;

            //We cache these too. Otherwise these keys will be uploaded on each interval
            this.Dictionary[key] = defaultText;// this.replaceVariables(defaultText, variables);
        }

        if (!this.Dictionary[key])
            return this.replaceVariables(defaultText, variables);

        return this.replaceVariables(this.Dictionary[key], variables);
    }

    public destroy() {
        this.destroyed = true;
    }

    private replaceVariables(str: string, variables: string[]): string {

        if (str === null || str === undefined)
            return str;

        str = str.replace('\n', '<br>')

        if (variables === null)
            return str;

        var splittedArray = str.split(this.PlaceHolderSymbol);

        if (splittedArray.length - 1 !== variables.length) {
            console.error(`Placeholder/Variable Count Mismatch. Translation failed for [${str}] using the provided variables ${variables}`);
            return '';
        }

        var newString = '';

        for (var i = 0; i < splittedArray.length - 1; i++)
            newString += splittedArray[i] + variables[i];

        newString += splittedArray[splittedArray.length - 1];

        return newString;
    }
}